import { render, staticRenderFns } from "./RecruitChooseSnippetDialog.vue?vue&type=template&id=61f4b1f0"
import script from "./RecruitChooseSnippetDialog.vue?vue&type=script&lang=js"
export * from "./RecruitChooseSnippetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports